var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typePie"},[_c('div',{ref:"pie",staticClass:"pie"})])
}
var staticRenderFns = []

export { render, staticRenderFns }